export default __webpack_public_path__ + "6589bef5de3d92872b6c4e760c44e941.png";